import englishTranslations from "./en.translations";
import polishTranslation from "./pl.translations";

export default {
  "en-US": englishTranslations,
  en: englishTranslations,
  "pl-PL": polishTranslation,
  pl: polishTranslation,
};
